import { Component, OnInit } from '@angular/core';
import {TournamentService} from './../../Service/Tournament/tournament.service'

@Component({
  selector: 'app-tournaments',
  templateUrl: './tournaments.component.html',
  styleUrls: ['./tournaments.component.css']
})
export class TournamentsComponent implements OnInit {
  tournamentList=[];
  leagueList=[];
  constructor( private _tournamentService:TournamentService) { }

  ngOnInit() {
    this.GetTournament();
    this.GetLeague();
  }

  GetTournament()
  {
   this._tournamentService.getTournament().subscribe(res=>
     {
       console.log(res);
       this.tournamentList= res.responseData;
     }
   )
  }

  GetLeague()
  {
    this._tournamentService.getLeague().subscribe(res=>
      {
        console.log(res);
        this.leagueList= res.responseData;
      })
  }

}
